import { Filter } from '~commonInfra/utils/Filter';

import { WebClientListResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { IUser } from '../../userManagement/users/serverApi/types/IUser';
import { GetUsersForDataAlertRequest, IGetUsersForDataAlertResult } from '../serverApi/requests/GetUsersForDataAlertRequest';


export class DataAlertUsersResource {
  private fetcher = new WebClientListResourceFetcher(GetUsersForDataAlertRequest, (result: IGetUsersForDataAlertResult) => result.users);

  public getUsersQuery(dataAlertId: string, filter: string): ResourceQuery<IUser> {
    return new ResourceQuery<IUser>(this.fetcher)
      .withExtraParams({ 'dataAlertId': dataAlertId })
      .withFilters([Filter.stringFieldMatches('displayName', filter)]);
  }
}

export const DataAlertUsers = new DataAlertUsersResource();